import React from 'react'
import Container from 'elements/Container'
import Staking from './Staking'
import BadgeModal from 'components/BadgeModal'
// import Banner from 'assets/images/banners/boxycat_banner.png'
import Banner from './Banner'

function Home() {
  return (
    <Container>
      {/* <Inventory /> */}
      <div
        style={{
          width: '100%'
        }}
      >
        <a
          href="https://boxycats.com"
          target="_blank"
          rel="noreferrer"
          style={{
            textDecoration: 'none',
            color: 'white'
          }}
        >
          <Banner />
        </a>
      </div>
      <div style={{ marginTop: '2rem' }}>
        <Staking />
      </div>
      <BadgeModal />
    </Container>
  )
}

export default Home
